import { YStack } from '@/components/ui/layout/layout';

import { SectionHeading } from './section-heading';

export const AgentNotes = ({ text }: { text: string }) => (
  <YStack className="gap-3">
    <SectionHeading title="Littlebird's notes" />
    {/* A "suggest edits in chat" button will sit here, so the user can ask Littlebird to revise these notes */}
    {text === '' ? (
      <span className="text-sm text-foreground-subtle">Nothing yet.</span>
    ) : (
      <p className="whitespace-pre-wrap text-sm text-foreground">{text}</p>
    )}
  </YStack>
);
